angular.module('property-price-list', ['core', 'project', 'property'])
    .factory('PropertyPriceList', function ($resource) {
        return $resource('/crm/api/property-price-list/:id/:action', {id: "@id", action: '@action'}, {
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/property-price-list/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/property-price-list/table-statistics'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            statuses: {method: 'GET', url: '/crm/api/property-price-list-status', isArray: true},
            action: {method: 'POST'},
            history: {method: 'GET', url: '/crm/api/property-price-list-history', isArray: true, params: {}},
        });
    })
    .service('PropertyPriceListService', function ($rootScope, modals, PropertyPriceList) {
        this.types = ['OFFER', 'BUDGET']
        this.accept = item => {
            let form = {
                propertyPriceList: item,
                status: "ACCEPTED",
                action: "accept"
            }
            return modals.open('app/property-price-list/status-modal.html', 'PropertyPriceListStatusChangeController', form, {}, "$ctrl")
        };
        this.reject = item => {
            let form = {
                propertyPriceList: item,
                status: "DRAFT",
                action: 'reject'
            }
            return modals.open('app/property-price-list/status-modal.html', 'PropertyPriceListStatusChangeController', form, {}, "$ctrl")
        };
        this.implement = item => {
            let form = {
                propertyPriceList: item,
                status: "IMPLEMENTED",
                action: 'implement'
            }
            return modals.open('app/property-price-list/status-modal.html', 'PropertyPriceListStatusChangeController', form, {}, "$ctrl")
        };
        this.notesEdit = item => {
            return modals.open('app/property-price-list/notes-modal.html', 'PropertyPriceListNotesController', item, {size: "sm"}, "$ctrl");
        }
        this.delete = item => modals.confirmDelete("wybrany rekord", () => PropertyPriceList.delete({id: item.id}, () => $rootScope.$broadcast('property-price-list.updated')).$promise);
        this.based = item => modals.confirm("Czy na pewno chcesz ustawić <strong>cennik bazowy</strong>?", () => PropertyPriceList.action({id: item.id, action: 'based'}, () => $rootScope.$broadcast('property-price-list.updated')).$promise);
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_PROPERTY_PRICE_LIST",
            path: "/property-price-list",
            ico: "fa fa-fw fa-building-o",
            name: 'property-price-list.menu',
            order: 83
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('propertyPriceListAdd', {
            parent: 'app',
            url: '/property-price-list/add',
            data: {
                authorities: ['ROLE_PROPERTY_PRICE_LIST']
            },
            views: {
                'content@': {
                    templateUrl: 'app/property-price-list/edit.html',
                    controller: 'PropertyPriceListDialogController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                data: () => {
                    return {
                        id: null,
                        status: "DRAFT",
                        attributes: [],
                        items: []
                    }
                }
            }
        });
        $stateProvider.state('propertyPriceListEdit', {
            parent: 'app',
            url: '/property-price-list/{id}/edit',
            data: {
                authorities: ['ROLE_PROPERTY_PRICE_LIST']
            },
            views: {
                'content@': {
                    templateUrl: 'app/property-price-list/edit.html',
                    controller: 'PropertyPriceListDialogController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                data: (PropertyPriceList, $stateParams) => PropertyPriceList.get({id: $stateParams.id}).$promise
            }
        })
        $stateProvider.state('propertyPriceListShow', {
            parent: 'app',
            url: '/property-price-list/{id}',
            data: {
                authorities: ['ROLE_PROPERTY_PRICE_LIST']
            },
            views: {
                'content@': {
                    templateUrl: 'app/property-price-list/show.html',
                    controller: 'PropertyPriceListShowController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                data: (PropertyPriceList, $stateParams) => PropertyPriceList.get({id: $stateParams.id}).$promise
            }
        })
        $stateProvider.state('propertyPriceList', {
            parent: 'app',
            url: '/property-price-list?{page:int}&{size:int}&sort&search&status&project',
            data: {
                authorities: ['ROLE_PROPERTY_PRICE_LIST']
            },
            views: {
                'content@': 'propertyPriceList'
            },
            resolve: {
                statistics: (PropertyPriceList, $stateParams) => PropertyPriceList.tableStatistics(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
                page: (PropertyPriceList, $stateParams) => PropertyPriceList.table(angular.copy($stateParams)).$promise
            }
        });
    })
